import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
// import Home from "../views/Home.vue";
import Index from "../views/Index.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/list",
    name: "List",
    component: Index,
  },
  {
    path: "/login",
    name: "Login",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Login.vue"),
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
  {
    path: "/",
    name: "Index",
    component: () =>
      import(/* webpackChunkName: "home" */ "../views/HomeNew.vue"),
  },
  {
    path: "/home-old",
    name: "Home",
    component: () =>
      import(/* webpackChunkName: "home" */ "../views/HomeOld.vue"),
  },
  {
    path: "/question",
    name: "Question",
    component: () =>
      import(/* webpackChunkName: "question" */ "../views/Question.vue"),
  },
  {
    path: "/question2",
    name: "Question2",
    component: () =>
      import(/* webpackChunkName: "question" */ "../views/Question2.vue"),
  },
  {
    path: "/assessment-report",
    name: "AssessmentReport",
    component: () =>
      import(
        /* webpackChunkName: "assessment-report" */ "../views/AssessmentReport.vue"
      ),
  },
  {
    path: "/health-package",
    name: "HealthPackage",
    component: () =>
      import(
        /* webpackChunkName: "health-package" */ "../views/HealthPackage.vue"
      ),
  },
  {
    path: "/package-select",
    name: "PackageSelect",
    component: () =>
      import(
        /* webpackChunkName: "package-for-you" */ "../views/PackageSelect.vue"
      ),
  },
  {
    path: "/package-for-you",
    name: "PackageForYou",
    component: () =>
      import(
        /* webpackChunkName: "package-for-you" */ "../views/PackageForYou.vue"
      ),
  },
  {
    path: "/payment",
    name: "Payment",
    component: () =>
      import(/* webpackChunkName: "payment" */ "../views/Payment.vue"),
  },
  {
    path: "/qr-code",
    name: "QRCode",
    component: () =>
      import(/* webpackChunkName: "qr-code" */ "../views/QRCode.vue"),
  },
  {
    path: "/package-details",
    name: "PackageDetails",
    component: () =>
      import(
        /* webpackChunkName: "package-details" */ "../views/PackageDetails.vue"
      ),
  },
  {
    path: "/add-card",
    name: "AddCard",
    component: () =>
      import(/* webpackChunkName: "add-card" */ "../views/AddCard.vue"),
  },
  {
    path: "/cart",
    name: "Cart",
    component: () => import(/* webpackChunkName: "cart" */ "../views/Cart.vue"),
  },
  {
    path: "/checkout",
    name: "Checkout",
    component: () =>
      import(/* webpackChunkName: "cart" */ "../views/Checkout.vue"),
  },
  {
    path: "/privacy",
    name: "Privacy",
    component: () =>
      import(/* webpackChunkName: "cart" */ "../views/Privacy.vue"),
  },
  {
    path: "/flash-sale",
    name: "FlashSalePage",
    component: () =>
      import(
        /* webpackChunkName: "FlashSalePage" */ "../views/FlashSalePage.vue"
      ),
  },
  // new design
  {
    path: "/home",
    name: "Home2",
    component: () =>
      import(/* webpackChunkName: "home2" */ "../views/HomeNew.vue"),
  },
  {
    path: "/show-all-package",
    name: "showAllPackage",
    component: () =>
      import(/* webpackChunkName: "home" */ "../views/ShowAllPackage.vue"),
  },
  {
    path: "/booking",
    name: "Booking",
    component: () =>
      import(/* webpackChunkName: "home" */ "../views/Booking.vue"),
  },
  {
    path: "/appointment-detail",
    name: "AppointmentDetail",
    component: () =>
      import(/* webpackChunkName: "home" */ "../views/AppointmentDetail.vue"),
  },
  {
    path: "/all-appointment",
    name: "AllAppointment",
    component: () =>
      import(
        /* webpackChunkName: "AllAppointment" */ "../views/AllAppointment.vue"
      ),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
